module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-9.862f404c.png";